import { CORE_CONSTANT } from '@salescore/core'

export const { VIEW_NEW_RECORD_PREFIX } = CORE_CONSTANT
